import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SaleChannelState } from '@store/reducers';

export const selectSaleChannelState = createFeatureSelector<SaleChannelState>('saleChannel');

export const selectSaleChannelLoading = createSelector(
  selectSaleChannelState,
  (state) => state.loading
);

export const selectSaleChannelList = createSelector(
  selectSaleChannelState,
  (state) => state.saleChannelList
);

export const selectSaleChannelError = createSelector(
  selectSaleChannelState,
  (state) => state.error
);

export const selectSaleChannelEditMode = createSelector(
  selectSaleChannelState,
  (state) => state.editMode
);

export const selectSaleChannelIsEditing = createSelector(
  selectSaleChannelState,
  (state) => state.isEditing
);

export const selectSaleChannelForm = createSelector(
  selectSaleChannelState,
  (state) => state.saleChannelForm
);

export const selectSaleChannelId = createSelector(
  selectSaleChannelState,
  (state) => state.saleChannelId
);

export const selectSaleChannel = createSelector(
  selectSaleChannelState,
  (state) => state.saleChannel
);
